import { encode as base64Encode, decode as base64Decode } from 'js-base64'

export function encode<T extends object>(
    val: T | undefined
): string | undefined {
    if (typeof val === 'undefined') {
        return undefined
    }

    const entries = Object.entries(val).filter((v) => {
        if (Array.isArray(v[1])) {
            return v[1].length > 0
        }

        return v[1] !== null && v[1] !== undefined // && v[1] !== ''
    })

    if (!entries.length) {
        return undefined
    }

    const json = JSON.stringify(Object.fromEntries(entries))

    return base64Encode(json, true)
}

export function decode<T>(val: string): T | undefined {
    try {
        return JSON.parse(base64Decode(val))
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e)
        return undefined
    }
}
